import { Flex, Text } from "@chakra-ui/react";
import Anexos from "components/Anexos";
import ButtonAnexarArquivos from "components/Button/ButtonAnexarArquivos";
import { AnexoResponse } from "core/features/arquivo/typings/index";
import useDeleteImagensParceiro from "core/features/parceiros/hooks/useDeleteImagensParceiro";
import useGetImagensParceiro from "core/features/parceiros/hooks/useGetImagensParceiro";
import useUploadImagemParceiro from "core/features/parceiros/hooks/useUploadImagemParceiro";
import { useCallback, useEffect, useState } from "react";
import { useLoading } from "ui/components/GlobalLoading";

function Fotos({ idParceiro }: { idParceiro: string }) {
  const [anexos, setAnexos] = useState<(File | AnexoResponse)[] | undefined>(
    []
  );
  const [disableButtonAnexar, setDisabledButtonAnexar] = useState(false);

  const { data, isLoading, refetch } = useGetImagensParceiro(idParceiro);

  const { mutate: handleDelete, isLoading: isLoadingDelete } =
    useDeleteImagensParceiro(idParceiro);

  useLoading(isLoading || isLoadingDelete);

  useEffect(() => {
    if (data) {
      setAnexos(data);
    }
  }, [data]);

  const onDeleteImage = useCallback(
    async (id: string) => {
      return new Promise((resolve, reject) => {
        handleDelete(id, {
          onSuccess: () => {
            refetch();
            resolve(null);
          },
          onError: reject,
        });
      });
    },
    [handleDelete, refetch]
  );

  return (
    <>
      <Flex mb="16px" gridGap={6}>
        <Text fontSize="18px" fontWeight="bold">
          Fotos
        </Text>
        <ButtonAnexarArquivos
          disabled={disableButtonAnexar}
          accept="image/*"
          buttonText="Adicionar"
          multiple
          maxFileSizeMb={20}
          currentFilesLength={anexos?.length || 0}
          onAnexar={(files) => {
            if (files) {
              setAnexos((state) => {
                if (!state) {
                  return files;
                }
                return [...state, ...files];
              });
            }
          }}
        />
      </Flex>

      {!isLoading ? (
        <Anexos
          anexos={anexos}
          setValue={setAnexos}
          autoUploadMutation={useUploadImagemParceiro}
          autoUploadMutationArgs={[idParceiro]}
          onRemove={onDeleteImage}
          onStartUploadMutation={() => setDisabledButtonAnexar(true)}
          onFinishUploadMutation={() => setDisabledButtonAnexar(false)}
          containerHeight={"fit-content"}
        />
      ) : null}
    </>
  );
}

export default Fotos;
